import { render, staticRenderFns } from "./AchievementChart.vue?vue&type=template&id=a55354dc&scoped=true"
import script from "./AchievementChart.vue?vue&type=script&lang=js"
export * from "./AchievementChart.vue?vue&type=script&lang=js"
import style0 from "./AchievementChart.vue?vue&type=style&index=0&id=a55354dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55354dc",
  null
  
)

export default component.exports